module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAUVBMVEVHcEwTKTcTKjkTKTkTKTkPHz8TKTgUKjkUKTkPJzcTJzcTKjgTKTgVKDgUKjkUKjoPLz8TKTcTKzgTKTgTKDkTKTkUKjgTKDgTKjgUKTgUKjnuD6qaAAAAGnRSTlMAoI/PnxDPv78gQJCfkN9/EIDP78+P35Dv73uOA7UAAACDSURBVBgZBcGHYYRAEAQwAQe7x+d3nv4LtQTOr3uyjQnY1+QYo5J1h33LmDCXbDvWvABeWZkZUA1LTtdMqIaZm3eDavC+y6C7f/+6myUyqKqPj6piie8DVIM6XDKhGmaGMwOq4ZrJJQ+AR254HhkT5jWfOzwvSY+xJbcdMJcjuf+c8A+SGAbz5ZNDdwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Vector.png
// module id = 975
// module chunks = 23